/**
 * The legend box in the corner of the map.
 *
 * Holds the shell only. Each layer formats its own labels and hands them
 * over, so the two layers share one look and one set of styles.
 */
/** The bar runs bottom to top, so the lowest value keeps the first color. */
export const legendGradient = (colors: string[]): string =>
  `linear-gradient(to top, ${colors.join(', ')})`;

export function MapLegend({
  title,
  colors,
  labels,
}: {
  title: string;
  colors: string[];  // low value first, matching the scale in the file
  labels: string[];  // top of the bar first
}) {
  const gradient = legendGradient(colors);
  return (
    <div className="map-legend">
      <div className="map-legend-title">{title}</div>
      <div className="map-legend-body">
        <div className="map-legend-bar" style={{ background: gradient }} />
        <div className="map-legend-labels">
          {labels.map((label) => (
            <span key={label}>{label}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
